/* eslint-disable class-methods-use-this */
import { GpsType } from '../../../../../global/components/layout/layout-models';
import { PersonalInfoWizard } from '../../personal-info/wizard/personal-info-wizard';
import { BenefitEnrollmentStep } from '../../../../arc/features/new-hire-enrollment/models/pension-enrollment-models';
import { AccountInfoRoutes } from '../../../constants/routes';
import { setCurrentMyCpgMidYearStep } from '../my-cpg-mid-year-slice';
import { TcsmEpiApiState } from '../../../../../root/tcsm-model';
import { AnnualEnrollmentKey } from '../../../../annual-enrollment/models/annual-enrollment-models';
import { DemographicAppKeys } from '../../../../../global/models/demographics-model';
import { MyCpgMidYearPersonalInfoAlertTypes } from '../../../../notification/notification-models';



export class MyMidYearPersonalInfoWizard extends PersonalInfoWizard {

	private readonly myCpgRoot: string;

	constructor(epiContent: TcsmEpiApiState, enrollmentContext: AnnualEnrollmentKey, app: DemographicAppKeys, dispatch: any, history: any, alerts?: MyCpgMidYearPersonalInfoAlertTypes[], myCpgRoot?: string) {
		super(epiContent, enrollmentContext, app, dispatch, history, alerts);
		this.myCpgRoot = myCpgRoot;
	}

	public getPageDescription(): string {
		return this.epiContent?.personalInfoSettingState?.epiContent?.newHireMemberPageIntro;
	}

	public useEffectDispatch(): void {
		this.dispatch(setCurrentMyCpgMidYearStep(BenefitEnrollmentStep.PERSONAL_INFORMATION));
	}

	public onSuccessRedirect(basePath: string): void {
		this.history.push(`${basePath}${AccountInfoRoutes.RelationshipsSegment}`);
	}

	// eslint-disable-next-line class-methods-use-this
	public isEnrollmentForm(): boolean {
		return true;
	}

	// eslint-disable-next-line class-methods-use-this
	public getGpsType(): GpsType {
		return GpsType.MYCPG_MIDYEAR_PERSONALINFO;
	}

	// eslint-disable-next-line class-methods-use-this
	public hasMaritalStatusSection(): boolean {
		return true;
	}


	public getSubmitButtonText() {
		return this.epiContent?.newHireSettingsState?.epiContent?.benefitEnrollmentPersonalInfoContinueText;
	}

	public getCancelButtonText() {
		return this.epiContent?.newHireSettingsState?.epiContent.benefitEnrollmentPersonalInfoBackText;
	}

	public onCancelRedirect(): void {


		this.history.push(this.myCpgRoot);

	}
}